import axios from './../../config/axios';

function changePasswordUntokened(data) {
    return axios().post(`/auth/change-password-untokened`, data);
}

export default {
    changePasswordUntokened
}